<template>
  <v-footer
    color="secondary"
    padless
    >
    <v-container fluid class="pa-0">
      <!-- <v-row justify="center" no-gutters>
          <v-col cols="12"
          class="secondary darken-1 text-center"
          >
            <v-btn
            text
            v-for="link in links"
            :key="link.name"
            class="white--text"
            @click="link.action"
            >
            {{ link.name }}
            </v-btn>
          </v-col>
      </v-row> -->
      <v-row justify="center" class="secondary darken-1 pt-1">
            <v-btn
            icon
            color="white"
            v-for="network in social"
            :key="network.name"
            :aria-label="network.name"
            class="mx-3"
            @click="openLink(network.link)"
            >
            <!-- :href="network.link" -->
                <v-icon>{{ network.icon }}</v-icon>
            </v-btn>
      </v-row>
      <v-row justify="center" class="mt-2">
        <v-btn text class="white--text">
          Microtone Guitars &copy;2021
        </v-btn>
        <v-btn
          text
          v-for="link in company"
          :key="link"
          class="white--text"
          >
            {{ link }}
        </v-btn>
        <privacy-policy classProp="white--text"></privacy-policy>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import {
  mdiFacebook, mdiTwitter, mdiInstagram, mdiYoutube,
} from '@mdi/js';

export default {
  name: 'Footer',
  data: () => ({
    links: [
      // 'Guitars',
      // 'Features',
      // 'Testimonials',
      {
        name: 'Contact Us',
        action: () => {
          // const us = 'microtoneguitars';
          // window.location.href = `mailto:info@${us}.com?subject=Hello there!&amp`;
          const mcContactFormURL = 'https://us5.list-manage.com/contact-form?u=00f788a46f27c498a7b257f53&form_id=a671da4f9ba814899726a0035dd3d6ca';
          window.open(mcContactFormURL, '_blank');
        },
      },
    ],
    social: [
      {
        name: 'facebook-link',
        icon: mdiFacebook,
        link: 'https://www.facebook.com/microtoneguitars',
      },
      {
        name: 'twitter-link',
        icon: mdiTwitter,
        link: 'https://twitter.com/microtoneguitar',
      },
      {
        name: 'instagram-link',
        icon: mdiInstagram,
        link: 'https://www.instagram.com/microtoneguitars/',
      },
      {
        name: 'youtube-link',
        icon: mdiYoutube,
        link: 'https://www.youtube.com/channel/UCVfUwVxGzkh66eNuBGSMmdw',
      },
    ],
    company: [
      // 'Terms',
      // 'Privacy',
    ],
  }),
  methods: {
    openLink(link) {
      window.open(link, '_blank');
    },
  },
};
</script>

<style>

</style>
